export const ANALYTICS_LANDING_TRACKING_EVENTS = {
  ANALYTICS_VISITED: 'Analytics Visited',
  DASHBOARD_VISITED: 'Dashboard Visited',
  FILTER_APPLIED: 'Filter Applied',
  DATA_EXPORTED: 'Data Exported',
} as const;

export const ANALYTICS_JOURNEYS_OVERVIEW_EVENTS = {
  ENTITY_FILTER_APPLIED: 'Entity Filter Applied',
  FILTERS_SELECTED: 'Selected Saved Dashboard',
  FILTERS_SAVED: 'Saved New Dashboard',
  FILTER_APPLIED: 'Filter Applied',
  DATA_EXPORTED: 'Data Exported',
  DASHBOARD_VISITED: 'Dashboard Visited',
  DASHBOARD_EXITED: 'Dashboard Exited',
} as const;

export const ANALYTICS_WORKFLOWS_OVERVIEW_EVENTS = {
  ENTITY_FILTER_APPLIED: 'Entity Filter Applied',
  FILTERS_SELECTED: 'Selected Saved Dashboard',
  FILTERS_SAVED: 'Saved New Dashboard',
  FILTER_APPLIED: 'Filter Applied',
  DATA_EXPORTED: 'Data Exported',
  DASHBOARD_VISITED: 'Dashboard Visited',
  DASHBOARD_EXITED: 'Dashboard Exited',
} as const;

export const ANALYTICS_JOURNEY_LINK_CLICK_INSIGHT_OVERVIEW_EVENTS = {
  ENTITY_FILTER_APPLIED: 'Entity Filter Applied',
  FILTERS_SELECTED: 'Selected Saved Dashboard',
  FILTERS_SAVED: 'Saved New Dashboard',
  FILTER_APPLIED: 'Filter Applied',
  DATA_EXPORTED: 'Data Exported',
  DASHBOARD_VISITED: 'Dashboard Visited',
  DASHBOARD_EXITED: 'Dashboard Exited',
} as const;

export const ANALYTICS_NPS_AND_SURVEYS_EVENTS = {
  ENTITY_FILTER_APPLIED: 'Entity Filter Applied',
  FILTERS_SELECTED: 'Selected Saved Dashboard',
  FILTERS_SAVED: 'Saved New Dashboard',
  FILTER_APPLIED: 'Filter Applied',
  DATA_EXPORTED: 'Data Exported',
  DASHBOARD_VISITED: 'Dashboard Visited',
  DASHBOARD_EXITED: 'Dashboard Exited',
  ENTITY_ADDED_IN_CHART: 'Entity added in chart',
} as const;

export const ANALYTICS_SURVEYS_V2_EVENTS = {
  ENTITY_FILTER_APPLIED: 'Entity Filter Applied',
  FILTERS_SELECTED: 'Selected Saved Dashboard',
  FILTERS_SAVED: 'Saved New Dashboard',
  FILTER_APPLIED: 'Filter Applied',
  DATA_EXPORTED: 'Data Exported',
  DASHBOARD_VISITED: 'Dashboard Visited',
  DASHBOARD_EXITED: 'Dashboard Exited',
  ENTITY_ADDED_IN_CHART: 'Entity added in chart',
} as const;

export const ANALYTICS_RECRUITER_PRODUCTIVITY = {
  FILTERS_SELECTED: 'Selected Saved Dashboard',
  FILTERS_SAVED: 'Saved New Dashboard',
  FILTER_APPLIED: 'Filter Applied',
  DATA_EXPORTED: 'Data Exported',
  DASHBOARD_VISITED: 'Dashboard Visited',
  DASHBOARD_EXITED: 'Dashboard Exited',
} as const;

export const ANALYTICS_CANDIDATE_SOURCE_PERFORMANCE_EVENTS = {
  FILTERS_SELECTED: 'Selected Saved Dashboard',
  FILTERS_SAVED: 'Saved New Dashboard',
  FILTER_APPLIED: 'Filter Applied',
  DATA_EXPORTED: 'Data Exported',
  DASHBOARD_VISITED: 'Dashboard Visited',
  DASHBOARD_EXITED: 'Dashboard Exited',
} as const;

export const ANALYTICS_REFERRALS_EVENTS = {
  JOB_FILTER_APPLIED: 'Job Filter Applied',
  FILTERS_SELECTED: 'Selected Saved Dashboard',
  FILTERS_SAVED: 'Saved New Dashboard',
  DATA_EXPORTED: 'Data Exported',
  DASHBOARD_VISITED: 'Dashboard Visited',
  DASHBOARD_EXITED: 'Dashboard Exited',
  FILTER_APPLIED: 'Filter Applied',
} as const;

export const ANALYTICS_HIRING_PIPELINE = {
  FILTERS_SELECTED: 'Selected Saved Dashboard',
  FILTERS_SAVED: 'Saved New Dashboard',
  FILTER_APPLIED: 'Filter Applied',
  DATA_EXPORTED: 'Data Exported',
  DASHBOARD_VISITED: 'Dashboard Visited',
  DASHBOARD_EXITED: 'Dashboard Exited',
} as const;

export const ANALYTICS_ALL_APPLICANTS = {
  DATA_EXPORTED: 'Data Exported',
  FILTER_APPLIED: 'Filter Applied',
  FILTER_CHANGED: 'Filter Changed',
  FILTER_VIEW_SAVED: 'Filter View Saved',
  EXPORT_CLICK: 'Export Click',
  DASHBOARD_VISITED: 'Dashboard Visited',
  DASHBOARD_EXITED: 'Dashboard Exited',
} as const;

export const ANALYTICS_VOICE_CALL_EVENTS = {
  ENTITY_FILTER_APPLIED: 'Entity Filter Applied',
  FILTERS_SELECTED: 'Selected Saved Dashboard',
  FILTERS_SAVED: 'Saved New Dashboard',
  FILTER_APPLIED: 'Filter Applied',
  DATA_EXPORTED: 'Data Exported',
  DASHBOARD_VISITED: 'Dashboard Visited',
  DASHBOARD_EXITED: 'Dashboard Exited',
} as const;

export const ANALYTICS_LINK_CLICK_INSIGHTS_UTM_EVENTS = {
  ENTITY_FILTER_APPLIED: 'Entity Filter Applied',
  LINK_CLICKED: 'Link Clicked',
  WORKFLOW_CLICKED: 'Workflow Clicked',
  NODE_CLICKED: 'Node Clicked',
  UTM_ANALYSIS_CLICKED: 'UTM Analysis Clicked',
  FILTERS_SELECTED: 'Selected Saved Dashboard',
  FILTERS_SAVED: 'Saved New Dashboard',
  FILTER_APPLIED: 'Filter Applied',
  DATA_EXPORTED: 'Data Exported',
  DASHBOARD_VISITED: 'Dashboard Visited',
  DASHBOARD_EXITED: 'Dashboard Exited',
} as const;

export const ANALYTICS_SCHEDULAR_PANEL_EVENTS = {
  PANEL_OPENED: 'Schedule Report Panel Opened',
  PANEL_CLOSED: 'Schedule Report Panel Closed',
  FREQUENCY_CHANGED: 'Schedule Frequency Changed',
  DAY_SELECTED: 'Schedule Day Selected',
  TIME_SELECTED: 'Schedule Time Selected',
  DATE_RANGE_SELECTED: 'Schedule Date Range Selected',
  EMAIL_ADDED: 'Schedule Email Recipient Added',
  EMAIL_REMOVED: 'Schedule Email Recipient Removed',
  REPORT_NAME_CHANGED: 'Schedule Report Name Changed',
  SUBJECT_CHANGED: 'Schedule Email Subject Changed',
  SCHEDULE_CREATED: 'Schedule Report Created',
  SCHEDULE_UPDATED: 'Schedule Report Updated',
  SCHEDULE_CANCELLED: 'Schedule Report Cancelled',
} as const;
